// ─── Trip Endpoints ───────────────────────────────────────────────────────────

export const API_GET_ORDERS = '/adminDashboard/allTripsWithFilter/';
export const API_GET_ORDER_BY_ID = '/trip/tripdetails/';
export const ASSIGN_DRIVER_TRIP = '/admin/trip/assignDriver';
export const API_UPDATE_NOTE = '/trip/add/adminNote';
export const API_DELETE_TRIP = '/trip/delete';
export const API_CHANGE_TRIP_STATUS = '/trip/changeTripStatus';
